<template>

    <div>


        <form>
            <div class="form-group">
                <label>Category</label>
                <select class="form-control" v-model="categorySelected" @change="getCategoryData()">
                    <option value="all">All</option>
                    <option v-for="category in allCategories" :value="category.id">
                        {{category.title}}
                    </option>
                </select>
            </div>
            <div v-if="displayKeyword">
                <div class="form-group">
                    <label>Keyword</label>
                    <input class="form-control" placeholder="Enter Keywords">
                </div>
            </div>
        </form>


        <div class="row">
            <div class="col-sm-12">
                <div class="resource-box" v-for="category in resourcesCategories">
                    <h2>{{category.title}}</h2>
                    <div v-for="resource in category.resources">
                        <a :href="mainUrl+'/resources/'+resource.get_slug.slug" class="resource-link">{{resource.title}}</a>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        components: {},
        data: function () {
            return {
                resourcesCategories: {},
                categorySelected: '',
                allCategories: {},
                displayKeyword: null,
            }
        },
        methods: {
            getData() {
                let that = this;
                console.log(process.env.MIX_API_URL);

                axios.get(process.env.MIX_API_URL + '/resource-categories')
                    .then(function (response) {
                        that.resourcesCategories = response.data;
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
                    .then(function () {
                    });
            },
            getAllCategories() {
                let that = this;
                console.log(process.env.MIX_API_URL);

                axios.get(process.env.MIX_API_URL + '/resource-categories-all')
                    .then(function (response) {
                        that.allCategories = response.data;
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
                    .then(function () {
                    });
            },
            getCategoryData(event) {

                let that = this;
                let id = this.categorySelected;
                if (this.categorySelected == "all") {
                    this.getData();
                } else {
                    axios.get(this.url + '/resource-categories/' + id)
                        .then(function (response) {
                            that.resourcesCategories = response.data;
                            // that.displayKeyword = true;
                        })
                        .catch(function (error) {
                            console.log(error);
                        })
                        .then(function () {
                        });
                }


            },

        },
        mounted: function () {
            this.getData();
            this.getAllCategories();
        },
        computed: {
            url: function () {
                return process.env.MIX_API_URL;
            },
            mainUrl: function () {
                return process.env.MIX_MAIN_URL;
            },

        }

    }

</script>
